import { FormContainer } from "@rhc-shared-components/form";
import { FormCheckbox } from "@rhc-shared-components/form-checkbox";
import { FormRadio } from "@rhc-shared-components/form-radio-select";
import { FormSelect } from "@rhc-shared-components/form-select-component";
import { Formik } from "formik";
import { type FC, forwardRef } from "react";
import { EOSContentTypes, ProjectContainerTypes, ProjectRedhatKeys, ProjectTypes } from "../../../../constants/project";
import { useVendorDetails } from "../../../../queries/productDetails";
import { useCreateModalStore } from "../CreateModalStore";
import {
	CreateFormKeys,
	getDistributionMethodType,
	ProjectContainerKeys,
	ProjectCreateModalKeys,
	RHELVersions,
	RhelCreateInitialValues,
	RhelCreateValidators,
	useCreateAndAttachComponent,
} from "../createConstants";

interface RhelContainerCreateFormProps {
	handleCreateModal: (showModal: boolean) => void;
	ref: any;
}

export const RhelContainerCreateForm: FC<RhelContainerCreateFormProps> = forwardRef((props, ref: any) => {
	const { createNewComponent } = useCreateAndAttachComponent(props.handleCreateModal, "new");
	const { modalData } = useCreateModalStore();
	const vendorDetails = useVendorDetails();
	return (
		<Formik
			innerRef={ref}
			initialValues={RhelCreateInitialValues}
			validationSchema={RhelCreateValidators}
			onSubmit={async (values) => {
				const distributionMethod = getDistributionMethodType().filter(
					(item) => item.value === values[CreateFormKeys.distributionMethod],
				)[0].key;
				const requestData = {
					[ProjectCreateModalKeys.name]: modalData.componentName,
					[ProjectCreateModalKeys.redhat]: {
						[ProjectRedhatKeys.productName]: "Red Hat Enterprise Linux",
						[ProjectRedhatKeys.productVersion]: values[ProjectRedhatKeys.productVersion],
					},
					[ProjectCreateModalKeys.type]: ProjectTypes.rhel,
					[ProjectCreateModalKeys.container]: {
						[ProjectContainerKeys.type]: ProjectContainerTypes.container,
						[ProjectContainerKeys.distributionMethod]: distributionMethod,
						[ProjectContainerKeys.osContentType]: EOSContentTypes.UBI,
						[ProjectCreateModalKeys.allowHostedRegistry]: values[CreateFormKeys.allowHostedContainerRegistry],
					},
					[ProjectCreateModalKeys.projectStatus]: "active",
				};
				await createNewComponent(requestData);
			}}
		>
			{({ values }) => (
				<FormContainer gridSpan={12}>
					<FormRadio
						name={CreateFormKeys.productVersion}
						label={"Red Hat Enterprise Linux Version"}
						isRequired={true}
						options={RHELVersions}
						subLabel={<div>What major version of RHEL will you be certifying your image for?</div>}
						subInfo={"This cant be changed after the project is created."}
						span={12}
					/>
					<FormSelect
						name={CreateFormKeys.distributionMethod}
						placeholder={"Select registry"}
						label={"Distribution Method"}
						subLabel={
							"Select the container registry that you will use for " +
							"container image distribution. This is the location from where " +
							"users will pull your container images."
						}
						subInfo={"This cant be changed after the project is created"}
						selectOptions={getDistributionMethodType()}
						isRequired={true}
						isFullWidth
					/>
					{values[CreateFormKeys.distributionMethod] === "Red Hat Container Registry" &&
						vendorDetails?.allow_hosted_container_registry && (
							<FormCheckbox
								id="allow-hosted-container-registry"
								data-testid="allow-hosted-container-registry"
								name={CreateFormKeys.allowHostedContainerRegistry}
								label=""
								subLabel="I need Red Hat to host my registry"
							/>
						)}
				</FormContainer>
			)}
		</Formik>
	);
});
